import r from '../utils/request'

export const getNotifications = () => {
  return r.get('/notifications')
}

// Leave out ids to mark every notification read
export const markNotificationsRead = (ids) => {
  return r.put('/notifications/read', ids ? { ids } : {})
}
